import React from 'react';
import SubmittedReviewFileUpload from './SubmittedReviewFileUpload';
import './CoachingReviewFileUploads.styl';
import connectToStores from 'alt-utils/lib/connectToStores';
import FileUploadScorecardStore from 'stores/scorecards/FileUploadScorecardStore';
import FileUploadScorecardActions from 'actions/scorecards/FileUploadScorecardActions';
import {List} from 'immutable';

@connectToStores
export default class SubmittedReviewFileUploads extends React.PureComponent {
  constructor(props) {
    super(props);

    this.loadData = this.loadData.bind(this);
  }

  static getStores() {
    return [FileUploadScorecardStore];
  }

  static getPropsFromStores() {
    return {
      scorecardResults: FileUploadScorecardStore.getState().get('scorecardResults'),
    };
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!this.props.calls.equals(prevProps.calls)) {
      this.loadData();
    }
  }

  loadData() {
    for (const [callId] of this.props.calls) {
      // fetches scorecards with scores included
      FileUploadScorecardActions.fetchScorecardResults.defer(callId);
    }
  }

  render() {
    const {
      users,
      calls,
      reviewFileUploads,
      highLevelScores,
      isLivecoachingPlan,
      scorecardResults,
      coachId,
      isRecipient,
      scorecardId,
      reviewId,
    } = this.props;

    if (!reviewFileUploads) {
      return null;
    }

    return (
      <div className="coaching-call-reviews">
        {reviewFileUploads.size === 0 && (
          <p className="no-calls-placeholder">No calls were added for this review.</p>
        )}
        {reviewFileUploads.size !== 0 && (
          <div>
            {reviewFileUploads.map(reviewFileUpload => (
              <SubmittedReviewFileUpload
                coachId={coachId}
                scorecardResults={scorecardResults.get(reviewFileUpload.fileuploadId, List())}
                users={users}
                calls={calls}
                reviewFileUpload={reviewFileUpload}
                key={reviewFileUpload.id}
                selectedContentDetailId={this.props.selectedContentDetailId}
                highLevelScores={highLevelScores}
                isLivecoachingPlan={isLivecoachingPlan}
                isRecipient={isRecipient}
                scorecardId={scorecardId}
                reviewId={reviewId}
              />
            ))}
          </div>
        )}
      </div>
    );
  }
}
